import { Collapse, CollapseItem, Button, Popover, Select, Option, Table, TableColumn, Checkbox } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();
import RaceResult from '@/components/shared/race-result/race-result.vue'
import RacesView from '@/components/user/ranking/races-view/races-view.vue'
import SeriesResultView from '@/components/user/ranking/series-result-view/series-result-view.vue'


export default {
    name: 'SeriesResult',
    props: ['selectedSerieIndex', 'selectedYearIndex'],
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
        [Popover.name]: Popover,
        [Select.name]: Select,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
        'race-result': RaceResult,
        'races-view': RacesView,
        'series-result-view': SeriesResultView
    },
    data() {
        return {
            isOnlyQualified: false,
            savedRequest: null,
            isUsersViewMode: true,
            isPreviewRaceResultsMode: false,
            isProcessing: false,
            errorMessage: null,
            data: [],
            years: ["Initialization"],
            series: ["Initialization"],
            selectedYear: null,
            selectedYearLabel: null,
            selectedSerie: null,
            selectedSerieLabel: null,
            noRacesEntry: { name: "No races found", id: null, enumValue: 0 },
            noUsersEntry: { name: "No users found", id: null },
            races: [],
            users: [],
            usersInput: [],
            usersFiltered: [],
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            page: 1,
            filterInput: null,
            activeRaceId: null,
            loadedResults: null,
            activeUserId: null,
            isProcessingRaces: false,
            ageGroupArray: [],
            ageGroupSelected: null,
            genderArray: [{ label: "Male", enumValue: 1 }, { label: "Female", enumValue: 2 }, { label: "Mixed", enumValue: 0 }],
            genderSelected: 1,
            clubArray: [],
            clubSelected: -1
        };
    },
    computed: {
        currentRaceName() {
            var race = this.races.filter(x => x.id == this.activeRaceId);
            return race && race.length ? race[0].name : null;
        },
        isAnyUsersLoaded() {
            return this.usersInput && this.usersInput.length && this.usersInput[0].id;
        },
        isVisibleWorkflow() {
            return this.years && this.years.length && this.series && this.series.length;
        },
        isNotVisibleWorkflow() {
            return !this.isVisibleWorkflow && !this.isProcessing;
        },
        from() {
            var array = this.users;
            var totalVal = this.usersFiltered.length;

            if (!array || !array.length || !array[0].id) return 0;

            var res = (this.page - 1) * this.perPage + 1;
            if (res >= totalVal) {
                if (totalVal - this.perPage > 0) {
                    res = totalVal - this.perPage;
                    if (res === 0) res = 1;
                }
                else {
                    res = 1;
                    this.page = 1;
                }
            }
            return res;
        },
        to() {
            var array = this.users;
            var totalVal = this.usersFiltered.length;

            if (!array || !array.length || !array[0].id) return 0;
            return totalVal > (this.page - 1) * this.perPage + this.perPage
                ? (this.page - 1) * this.perPage + this.perPage
                : totalVal;
        },
        total() {
            var array = this.users;
            var totalVal = this.usersFiltered.length;
            return (!array || !array.length || !array[0].id)
                ? 0
                : totalVal;
        }
    },
    methods: {
        serialize(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },
        showError(message) {
            if (!message) message = 'Something went wrong. Incorrect request!';
            this.$notify({ message: message, type: 'danger', timeout: 3000 });
        },
        showSuccess(message) {
            if (!message) message = 'Operation success!';
            this.$notify({ message: message, type: 'success', timeout: 3000 });
        },
        console(message) {
            if (console && console.log) {
                if (message) console.log(message);
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        setTabsInit() {
            var self = this;
            if (self.series && self.series.length > 1) {
                self.selectedSerieLabel = self.series[self.selectedSerieIndex > 1 ? self.selectedSerieIndex : 1].label;
                self.selectedSerie = self.series[self.selectedSerieIndex > 1 ? self.selectedSerieIndex : 1].enumValue;
            }
            if (self.years && self.years.length) {
                self.selectedYear = self.years[self.selectedYearIndex > -1 ? self.selectedYearIndex : 0];
                self.selectedYearLabel = self.years[self.selectedYearIndex > -1 ? self.selectedYearIndex : 0] + '';
            }
            self.updateUsers();
        },
        init() {
            var self = this;
            self.isProcessing = true;
            self.races = [self.noRacesEntry];
            self.users = [self.noUsersEntry];
            self.years = [];
            self.series = [];
            svc.rankingInitSeriesSettings()
                .then(response => {
                    self.isProcessing = false;

                    if (response && response.body) {
                        self.series = response.body.series;
                        self.years = response.body.years
                        self.setTabsInit();
                    }
                    else {
                        self.errorMessage = "Something went wrong, please contact with dev team!";
                    }
                }, () => {
                    self.isProcessing = false;
                    self.errorMessage = "Something went wrong, please contact with dev team!";
                });

            EventBus.$off('view-race-results');
            EventBus.$on('view-race-results', id => self.loadRaceResult(id));
        },
        handleTabChangeSerie(tabIndex) {
            if (this.selectedSerieIndex != tabIndex + 1) {
                if (this.isProcessing) {
                    return;
                }
                this.selectedSerie = this.series[tabIndex + 1].enumValue;
                this.updateUsers(this.selectedSerie);
                EventBus.$emit('ranking-layout-set-init-serie-index', tabIndex + 1);
            }
        },
        handleTabChangeYear(tabIndex) {
            if (this.selectedYearIndex != tabIndex) {
                if (this.isProcessing) {
                    return;
                }
                this.selectedYear = this.years[tabIndex];
                this.updateUsers();
                EventBus.$emit('ranking-layout-set-init-year-index', tabIndex);
            }
        },
        clearRaces() {
            var self = this;
            self.races = [];
        },
        clearUsers() {
            var self = this;
            self.users = [];
            self.usersFiltered = [];
            self.usersInput = [];
        },
        previousPage() {
            this.page--;
            this.changePage(this.page)
        },
        nextPage() {
            this.page++;
            this.changePage(this.page)
        },
        changePage(newPage) {
            this.changePageUsers(newPage);
        },
        changePageUsers(newPage) {
            var from = newPage ? (newPage - 1) * this.perPage : (this.page - 1) * this.perPage;
            if (from >= this.usersFiltered.length) {
                if (this.usersFiltered.length - this.perPage > 0) {
                    from = this.usersFiltered.length - this.perPage;
                }
                else {
                    from = 0;
                    this.page = 1;
                }
            }

            if (!newPage) {
                this.page = 1;
            }
            this.users = [...this.usersFiltered].splice(from, this.perPage);
        },
        searchForUsers(savePage) {
            if (!savePage) {
                this.page = 1;
            }

            var lowerfilterInput = this.filterInput && this.filterInput.length ? this.filterInput.toLocaleLowerCase() : null;
            var genderValue = this.genderSelected;
            var ageGroupValue = this.ageGroupSelected;
            var clubValue = this.clubSelected;
            var isOnlyQualifiedValue = this.isOnlyQualified; 
            this.usersFiltered = [...this.usersInput
                .filter(user => {
                    return (!lowerfilterInput ||
                        user.userName.toLocaleLowerCase().indexOf(lowerfilterInput) > -1 ||
                        user.triathlonId == lowerfilterInput ||
                        (user.clubName && user.clubName.toLocaleLowerCase().indexOf(lowerfilterInput) > -1))
                        && (!genderValue || genderValue == user.gender)
                        && (!ageGroupValue || ageGroupValue == user.ageGroup)
                        && (clubValue === -1 || clubValue == user.clubId)
                        && (!isOnlyQualifiedValue || user.place);
                })];
            this.users = [...this.usersFiltered].splice(0, this.perPage);
        },
        prepareRacesFromResponse(response) {
            var self = this;
            if (response && response.body && response.body.isSuccess) {
                self.races = response.body.outputData && response.body.outputData.length ? response.body.outputData : [self.noRacesEntry];
            }
            else {
                self.errorMessage = response && response.body && response.body.message ? response.body.message : "Error while retrieving data.";
            }
        },
        prepareUsersFromResponse(response) {
            var self = this;
            if (response && response.body && response.body.isSuccess) {
                self.usersInput = response.body.outputData && response.body.outputData.length ? response.body.outputData : [self.noUsersEntry];
                self.initUsersFilters();
                self.searchForUsers();
            }
            else {
                self.errorMessage = response && response.body && response.body.message ? response.body.message : "Error while retrieving data.";
            }
        },
        initUsersFilters() {
            var self = this;
            self.ageGroupArray = [{ label: "All", enumValue: null }];
            self.clubArray = [];

            self.usersInput.forEach(record => {
                if (record.ageGroup && record.ageGroupString &&
                    !self.ageGroupArray.filter(group => group.enumValue == record.ageGroup).length) {
                    self.ageGroupArray.push({ label: record.ageGroupString, enumValue: record.ageGroup });
                    self.ageGroupArray = [...self.ageGroupArray]
                        .sort((a, b) => { return a["enumValue"] > b["enumValue"] ? 1 : -1; });
                }

                if (record.clubId && record.clubName &&
                    !self.clubArray.filter(club => club.id == record.clubId).length) {
                    self.clubArray.push({ label: record.clubName, id: record.clubId })
                }
            });
            self.clubArray = [...self.clubArray]
                .sort((a, b) => { return a["label"] > b["label"] ? 1 : -1; });
            self.clubArray.unshift({ label: "All", id: -1 }, { label: "WithoutClub", id: null });
        },
        updateRaces() {
            var self = this;
            self.clearRaces()
            if (self.activeUserId > 0) {
                self.isProcessingRaces = true;
                const filterQuery = self.serialize({ serieType: self.selectedSerie, year: self.selectedYear, userId: self.activeUserId });
                svc.rankingGetSeriesRacesForUser(filterQuery)
                    .then(response => {
                        self.prepareRacesFromResponse(response);
                        self.isProcessingRaces = false;
                    }, () => {
                        self.errorMessage = "Error while retrieving data."
                        self.isProcessingRaces = false;
                    });
            }
        },
        updateUsers() {
            var self = this;
            self.clearUsers()
            if (self.selectedYear && self.selectedSerie) {
                const filterQuery = self.serialize({ serieTypeEnum: self.selectedSerie, year: self.selectedYear, genderEnum: 0 });
                if (filterQuery != self.savedRequest) {
                    self.savedRequest = filterQuery;
                }
                else {
                    return;
                }
                self.isProcessing = true;
                svc.rankingGetSeries(filterQuery)
                    .then(response => {
                        self.prepareUsersFromResponse(response);
                        self.isProcessing = false;
                    }, () => {
                        self.errorMessage = "Error while retrieving data."
                        self.isProcessing = false;
                    });
            }
        },
        loadRaceResult(activeRaceId) {
            this.activeRaceId = activeRaceId;
            this.isPreviewRaceResultsMode = this.activeRaceId > 0;
            EventBus.$emit('race-result-reload');
        },
        openUserData(userData) {
            if (this.activeUserId == userData.userId) {
                return;
            }
            this.activeUserId = userData.userId;
            this.updateRaces();
        },
        download() {
            EventBus.$emit('race-result-download');
        },
        switchPreview() {
            var self = this;
            self.isPreviewRaceResultsMode = !self.isPreviewRaceResultsMode;
            setTimeout(() => {
                var item = document.getElementById('head-' + self.activeRaceId);
                if (item && item.getBoundingClientRect && item.getBoundingClientRect()) {
                    window.scrollTo({ top: item.getBoundingClientRect().y - 100, behavior: 'smooth' });
                }
            }, 10)
        }
    },
    mounted() {
        var self = this;
        self.init();

        EventBus.$off('series-result-update-races')
        EventBus.$on('series-result-update-races', (userId) => {
            self.activeUserId = userId;
            self.updateRaces();
        });
        EventBus.$off('series-result-load-race-results');
        EventBus.$on('series-result-load-race-results', (raceId) => {
            self.loadRaceResult(raceId);
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/user/ranking/series-result/series-result.js